import { Button, Card, Col, Drawer, Form, notification, Row } from 'antd'
import moment from 'moment/moment'
import React from 'react'
import { connect } from 'react-redux'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import {
  formItemLayout,
  DisplayDate
} from '../../components/_utils/appUtils'
import { addAbstractNoteFxn, listAbstractNotesFxn } from './actions'

@Form.create()
class AbstractNotesDrawer extends React.Component {
  state = {
    noteData: []
  }

  componentDidMount() {
    this.loadNotes()
  }

  handleSubmit = e => {
    const {
      dispatch,
      form,
      abstractId, // Changed from onlineSubmissionId
    } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.abstractId = abstractId
        valData.time = moment().format() // Use standard ISO for better backend parsing

        let resp = await addAbstractNoteFxn(valData) // Using the Abstract action

        if (resp && resp.success) {
          notification.success({
            message: resp.message || 'Note added successfully'
          })
          form.resetFields()
          this.loadNotes()
        }
      } else {
        notification.error({
          message: 'Please enter all required fields.'
        })
      }
    })
  }

  loadNotes = () => {
    return new Promise(async resolve => {
      let { abstractId } = this.props
      // Fetching notes using the Abstract-specific list action
      let data = await listAbstractNotesFxn({ abstractId })

      this.setState({ noteData: data || [] })
      resolve(data)
    })
  }

  render() {
    const { noteData } = this.state
    const {
      form: { getFieldDecorator },
      visible,
      onClose
    } = this.props

    let inputSchema = [
      {
        label: 'Add Note',
        key: 'note',
        required: true,
        type: 'textArea',
        placeholder: 'Enter your internal note here...'
      }
    ]

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        width={'70%'}
        title={'Abstract Notes'}>
        <Card bordered={false}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>
            <Row gutter={16}>
              {inputSchema.map((item, key) => (
                <Col span={24} key={key}>
                  <GetEachFormFields
                    item={item}
                    getFieldDecorator={getFieldDecorator}
                    formItemLayout={formItemLayout}
                  />
                </Col>
              ))}
              <Col span={24}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Submit Note
                  </Button>
                </Form.Item>
              </Col>
              <Col span={24}>
                {noteData && noteData.length > 0 ? (
                  noteData.map((item, i) => (
                    <div key={i} className="custom_card mb10">
                      <Card
                        bordered={true}
                        title={item.addedBy || 'Admin'}
                        extra={
                          <small>
                            {moment(item.time || item.createdAt).format('DD.MM.YYYY, h:mm A')}
                          </small>
                        }>
                        <div style={{ whiteSpace: 'pre-wrap' }}>{item.note}</div>
                      </Card>
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: 'center', color: '#999', marginTop: 20 }}>
                    No notes available for this abstract.
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(null, mapDispatchToProps)(AbstractNotesDrawer)
